import { useAvatarContext } from "@/context/AvatarContext";

export function useAvatar() {
  return useAvatarContext();
}
